import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";

const ViewImageModal = ({ props }) => {
  // console.log(props)
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <div onClick={onOpen} style={{ width: "100%" }}>
        <img src={`https://missionlife.iiita.ac.in//${props.url}`} alt="" />
      </div>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        style={{ width: "80vw", display: "flex", alignItems: "center" }}
      >
        <ModalOverlay style={{ display: "flex", alignItems: "center" }} />
        <ModalContent
          style={{ width: "80vw", display: "flex", alignItems: "center" }}
        >
          <ModalBody
            style={{
              display: "flex",
              padding: "0",
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "50vw",
            }}
          >
            <img
              src={`https://missionlife.iiita.ac.in//${props.url}`}
              alt=""
              style={{ maxWidth: "50vw" }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewImageModal;
